import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedVideos from './components/FeaturedVideos';
import CategoriesSection from './components/CategoriesSection';
import LatestVideos from './components/LatestVideos';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedVideos />
        <CategoriesSection />
        <LatestVideos />
      </main>
      <Footer />
    </>
  );
}